import React from 'react'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { generatedMetaStructureAtom } from '../../atoms'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Typography,
  Box,
  Card,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { LessonStructure } from '../../types'

export const MetaStructureVisor = () => {
  const [metaStructure] = useAtom(generatedMetaStructureAtom)

  const lessons: LessonStructure[] = metaStructure.lessons || []
  return (
    <Paper>
      {lessons.map((lesson) => (
        <Accordion key={`unit-${lesson.unit}-lesson-${lesson.id}`}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>
              <strong>{lesson.name}</strong> | Unit: {lesson.unit} | Lesson:{' '}
              {lesson.id}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {lesson.parts.map((part, index) => (
              <Box
                key={`unit-${lesson.unit}-lesson-${lesson.id}-part-${index}`}
                m={1}
                p={1}
              >
                <Card
                  key={`u-${lesson.unit}-l-${lesson.id}-p-${index}-content`}
                  sx={{ padding: 2 }}
                >
                  <Accordion
                    key={`u-${lesson.unit}-l-${lesson.id}-p-${index}-acc`}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>
                        <strong>{part.name}</strong>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <strong>Content:</strong>
                      </Typography>
                      {part.content}
                    </AccordionDetails>
                  </Accordion>
                </Card>
                <Card
                  key={`u-${lesson.unit}-l-${lesson.id}-p-${index}-subparts`}
                  sx={{ padding: 2 }}
                >
                  <strong>Parts:</strong> {part.parts?.length}
                  {part.parts?.map((subpart, subindex) => {
                    return (
                      <Accordion key={`subpart-${subindex}`}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography>
                            <strong>{subpart.name}</strong>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>{subpart.content}</AccordionDetails>
                      </Accordion>
                    )
                  })}
                </Card>
              </Box>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </Paper>
  )
}
